module.exports = __webpack_public_path__ + "img/s-get-app.0948cadf.svg";